"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authentication = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const package_1 = require("../package");
const auth_1 = require("../ontologies/auth");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const UserAccount_1 = require("lincd-sioc/lib/shapes/UserAccount");
const ShapeClass_1 = require("lincd/lib/utils/ShapeClass");
let Authentication = class Authentication extends Shape_1.Shape {
    // @objectProperty({
    //   path: auth.user,
    //   maxCount: 1,
    // })
    // get user():Person {
    //   return this.getOneAs(auth.user,Person);
    // }
    //
    // set user(val: Person) {
    //   this.overwrite(auth.user,val.namedNode);
    // }
    get userAccount() {
        return (0, ShapeClass_1.getShapeOrSubShape)(this.getOne(auth_1.auth.userAccount), UserAccount_1.UserAccount);
    }
    set userAccount(val) {
        this.overwrite(auth_1.auth.userAccount, val.namedNode);
    }
    get userAccountNode() {
        return this.getOne(auth_1.auth.userAccount);
    }
    set userAccountNode(val) {
        this.overwrite(auth_1.auth.userAccount, val);
    }
    //TODO: we need a more generic way of determining which data needs to be send/converted for specific shapes
    // here we make sure also the data of the user, roles & scopes is included
    // perhaps we can convert Shapes in JSONWriter, by using their unique URI.
    // The frontend should throw an error if that shape is not bundled
    // and the implementation gets the quads from getShapeQuads / getData or something like this
    getDataQuads() {
        let userAccount = this.userAccount;
        let user = userAccount.accountOf;
        let scopes = userAccount.scopes;
        return super.getDataQuads().concat(userAccount ? userAccount.getDataQuads() : [], user ? user.getDataQuads() : [], 
        //TODO: implement getDataQuads for sets
        scopes.getAllQuads());
    }
};
exports.Authentication = Authentication;
Authentication.targetClass = auth_1.auth.Authentication;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: auth_1.auth.userAccount,
        maxCount: 1,
    }),
    __metadata("design:type", UserAccount_1.UserAccount),
    __metadata("design:paramtypes", [UserAccount_1.UserAccount])
], Authentication.prototype, "userAccount", null);
exports.Authentication = Authentication = __decorate([
    package_1.linkedShape
], Authentication);
//# sourceMappingURL=Authentication.js.map